jQuery(document).ready(function($) {

    let contentHeightCss = 189;
    let originalClampLine = 7;
    let nextClampLine = 15;

    function showMore() {   
        const card = $(this);
        const cardHeight = card.height();
        const descriptionContainer = card.find('.description_container');
        const content = card.find('.content');
        const title = card.find('.title');
        const image = card.find('.image');
        const imageHeight = parseInt(image.css("height"));
        const contentHeight = content[0].scrollHeight;
        const remainingContentHeight = contentHeight - contentHeightCss;

        contentHeightCss = parseInt(content.css("height"));
        titleLine = Math.ceil(title.height() / parseInt(title.css("line-height")));
        nextClampLine = (card.data('type') === 'cinema' || card.data('type') === 'movie') ? 18 : 15;
        const clampLine = nextClampLine - titleLine;

        content.css('height', Math.min(cardHeight, contentHeight) + 'px');
        content.css('transform', 'translateY(-' + Math.min((imageHeight + 0.5), remainingContentHeight) + 'px');
        descriptionContainer.css('-webkit-line-clamp', `${clampLine}`);

        console.log('Card: ', cardHeight, 'Content: ', contentHeight, 'Remaining Content: ', remainingContentHeight, 'Content CSS: ', contentHeightCss, 'Title lines: ', titleLine);
    }

    function showLess() {
        const card = $(this);
        const content = card.find('.content');
        content.css('height', contentHeightCss);
        content.css('transform', 'translateY(0px)');
    }

    function handleCard(card) {
        showLess();
        let isClickedMobile = false;
        if (window.innerWidth <= 768) {
            card.on('click', function() {
                if (isClickedMobile) {
                    showLess.call(this);
                    isClickedMobile = false;
                } else {
                    showMore.call(this);
                    isClickedMobile = true;
                }
            });
        } else {
            card.off('click');
            card.mouseenter(function() {
                showMore.call(this);
            });
            card.mouseleave(function() {
                showLess.call(this);
            });
        }
    }

    const card = $(".info_box_container");
    handleCard(card);
});
